import { AppId } from '@inno-tools/container-bridge'
import { appConfigs } from 'shared/configs/appConfigs'
import { UserProfile } from 'src/shared/components/MainLayout/components/UserProfile'

import styles from './AppSessionTopBar.module.scss'

export const AppSessionTopBar = () => {
  const afterSalesConfig = appConfigs[AppId.AFTER_SALES]

  return (
    <header className={styles.topBar}>
      <div className={styles.appItem}>
        <img
          src={afterSalesConfig.icon}
          alt={afterSalesConfig.label}
          width={28}
          height={28}
          className={styles.appIcon}
        />
        <span className={styles.appLabel}>{afterSalesConfig.label}</span>
      </div>
      <div className={styles.userSection}>
        <UserProfile />
      </div>
    </header>
  )
}
